import { niceNumber } from "@/lib/util";
import { SHIFT_MODIFIERS } from "@/lib/models";

import type { IShiftLineRec, IPreplanningOverrideDataLine } from "@/lib/backend/manufacturing2.generated.types";

const shiftModifierToClassName = (shiftModifier: SHIFT_MODIFIERS): string => {
    switch (shiftModifier) {
        case SHIFT_MODIFIERS.tpm:
            return "bg-yellow";
        case SHIFT_MODIFIERS.value1:
            return "bg-red";
        case SHIFT_MODIFIERS.value2:
            return "bg-blue";
        default:
            return "";
    }
};

export type PreplanningTableShiftCellProps = {
    shift: IShiftLineRec;
    shift_changed: boolean;
    override_shift: IPreplanningOverrideDataLine;
    display_quantity: number;
};

/**
 * Displays the shift cell in the preplanning table.
 * It shows the shift status, override shift indicator, and display quantity.
 */
const PreplanningTableShiftCell = ({
    shift,
    shift_changed,
    override_shift,
    display_quantity,
}: PreplanningTableShiftCellProps) => {
    const modifierClass = override_shift ? shiftModifierToClassName(override_shift.type as SHIFT_MODIFIERS) : "";

    return (
        <span className="d-flex align-items-center justify-content-end w-100 gap-2">
            {shift.enabled
                ? shift_changed && <i className="fas fa-check text-success mr-auto" />
                : shift_changed && <i className="fas fa-times text-danger mr-auto" />}
            {override_shift && <i className={`fas fa-info icon-round mr-auto ${modifierClass}`} />}
            <span>{niceNumber(display_quantity)}</span>
        </span>
    );
};

export default PreplanningTableShiftCell;
